import request from '@/utils/request'

// 下载
export const trackList = (params: any) =>
  request({
    url: '/front/track-show-config/search',
    method: 'get',
    params
  })

// api/index/get-dropdown
export const getDropdown = (params: any) =>
  request({
    url: '/api/index/get-dropdown',
    method: 'get',
    params
  })

export const trackSubmit = (params: any) =>
  request({
    url: '/front/track-show-config/submit',
    method: 'post',
    data: params
  })

export const updateStatus = (params: any) =>
  request({
    url: '/front/track-show-config/update-status',
    method: 'post',
    data: params
  })
